import { type SerializedPageStructure } from '@wix/document-services-types'
import { type Schema } from '@wix/wix-data-schema-types'

import {
  applyModifiers,
  removeReferenceComponents,
  setPageLegacyIndexability,
  setPageLoginRequirement,
} from './utils'
import { addComponentsForFields } from './add-components-for-fields'
import { rebindFilterDataset } from './rebindFilterDataset'
import { rebindItemDisplayName } from './rebindItemDisplayName'
import { rebindItemSelector } from './rebindItemSelector'
import { rebindOrRemoveViewItemAction } from './rebindOrRemoveViewItemAction'
import { rebindSelectItemAction } from './rebindSelectItemAction'
import { renameRouterDataset } from './renameRouterDataset'

export const modifyEditPage = ({
  page,
  collectionId,
  fields,
  displayFieldKey,
  pageLinkFieldKey,
  routerDatasetName,
}: {
  page: SerializedPageStructure
  collectionId: string
  fields: Schema['fields']
  displayFieldKey: string
  pageLinkFieldKey: string
  routerDatasetName: string
}): SerializedPageStructure =>
  applyModifiers({
    target: page,
    modifiers: {
      makePageNonIndexable: page =>
        setPageLegacyIndexability({ page, pageIsIndexable: false }),
      restrictPageAccessToMembers: page =>
        setPageLoginRequirement({ page, pageRequiresLogin: true }),
      removeReferenceComponents,
      renameRouterDataset: page =>
        renameRouterDataset({ page, name: routerDatasetName }),
      rebindItemDisplayName: page =>
        rebindItemDisplayName({ page, displayFieldKey }),
      rebindFilterDataset: page => rebindFilterDataset({ page, collectionId }),
      rebindItemSelector: page => rebindItemSelector({ page, displayFieldKey }),
      rebindSelectItemAction: page =>
        rebindSelectItemAction({ page, pageLinkFieldKey }),
      addComponentsForFields: page => addComponentsForFields({ page, fields }),
      rebindOrRemoveViewItemAction: page =>
        rebindOrRemoveViewItemAction({ page, fields, displayFieldKey }),
    },
  })
